import { SetState } from 'zustand';

export interface IRouterSlice {
    routerHistory: string[],
    setRouterHistory: (content: string[]) => void;
}

const createRouterSlice = (set: SetState<IRouterSlice>) => ({
  routerHistory: [],
  setRouterHistory: (content: string[]) => {
    set({ routerHistory: content });
  },
});

export default createRouterSlice;
